import React from "react";

export function MaterialIcon(props) {
    return <i className={`material-icons ${props.className || ""}`}
              onClick={props.onClick}>{props.icon}</i>
}